import { useContext } from 'react';
import { Button } from 'antd';
import { AppContext } from '@utils/AppContext';
import eventBus from '@utils/eventBus';
import { SELECT_ORG_TYPE } from '@utils/CONST';
import Utils from '@utils/utils';
import styles from './index.module.scss';

const SEARCH_EMPTY_IMG = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/material-manage/enterprise-empty.png';

const EnterpriseEmpty = () => {
    const { globalOrgInfo } = useContext(AppContext);

    // 判断是否有企业账户：orgList 中有非个人的组织
    const hasOrg = globalOrgInfo?.orgList?.length > 1;

    const handleClick = () => {
        // 先判断登录
        const isLogin = Utils.checkLoginStatus(() => handleAction());
        if (!isLogin) return;
        handleAction();
    };

    const handleAction = () => {
        if (hasOrg) {
            // 有企业账户 → 打开切换团队弹窗
            eventBus.emit('OPEN_SELECT_TEAM', { type: SELECT_ORG_TYPE.CHANGEORG, noPersonal: true });
        } else {
            // 没有企业账户 → 打开创建团队弹窗
            eventBus.emit('OPEN_CREATE_TEAM');
        }
    };

    return (
        <div className={styles.EnterpriseEmpty}>
            <div className={styles.content}>
                <img src={SEARCH_EMPTY_IMG} alt="" className={styles.emptyImg} />
                <p className={styles.title}>该功能为企业版专属</p>
                <p className={styles.desc}>请切换至企业账号，可以查看和管理企业参考图</p>
                <p className={styles.desc}>企业版支持批量生图、素材共享等高级功能</p>
                <Button type="primary" className={styles.actionBtn} onClick={handleClick}>
                    {hasOrg ? '切换账号' : '免费创建团队'}
                </Button>
            </div>
        </div>
    );
};

export default EnterpriseEmpty;
